import { Link } from "react-router-dom";
import { FileText, FileEdit, ClipboardList, ArrowUpRight } from "lucide-react";

 const CARDS = [
{
    key: "fill",
    title: "Fill My Form",
    desc: "Professional online form filling service.",
    icon: FileText,
    accent: "from-[#3BC7FF] to-[#00D4FF]",
    to: "/Fill_My_Form",
},
  // {
  //   key: "modify",
  //   title: "Modify My Form",
  //   desc: "Update or correct your previously submitted forms.",
  //   icon: FileEdit,
  //   accent: "from-[#7B61FF] to-[#3BC7FF]",
  //   to: "/services",
  // },
  // {
  //   key: "registers",
  //   title: "Registers",
  //   desc: "Access various government and private registration services.",
  //   icon: ClipboardList,
  //   accent: "from-[#00D4FF] to-[#7B61FF]",
  //   to: "/services",
  // },
];

export default function Dashboard() {
  return (
    <section
      className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8"
      data-testid="dashboard-page"
    >
      <div
        className="grid grid-cols-1 md:grid-cols-3 gap-6"
        data-testid="dashboard-service-cards"
      >
        {CARDS.map((card, index) => {
          const Icon = card.icon;

          return (
            <Link
              key={card.key}
              to={card.to}
              data-testid={`dashboard-card-${card.key}`}
              className="group relative glass-card rounded-3xl p-6 hover-lift overflow-hidden fade-in-up"
              style={{ animationDelay: `${index * 120}ms` }}
            >
              {/* Background Glow */}
              <div
                className={`absolute -top-16 -right-16 h-48 w-48 rounded-full bg-gradient-to-br ${card.accent} opacity-20 blur-3xl group-hover:opacity-40 transition`}
              />

              {/* Icon */}
              <div
                className={`relative h-16 w-16 rounded-2xl bg-gradient-to-br ${card.accent} p-[2px]`}
              >
                <div className="h-full w-full rounded-2xl bg-background/80 backdrop-blur flex items-center justify-center">
                  <Icon className="h-7 w-7 text-foreground" />
                </div>
              </div>

              {/* Title */}
              <h2 className="mt-6 text-2xl font-display font-semibold">
                {card.title}
              </h2>

              {/* Description */}
              <p className="mt-3 text-sm text-muted-foreground leading-relaxed">
                {card.desc}
              </p>

              {/* Button */}
              <div className="mt-6 inline-flex items-center gap-2 text-primary font-semibold">
                Open
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}